/* eslint-disable react/jsx-no-comment-textnodes */
import {
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Divider,
  FormControl,
  FormLabel,
  Grid,
  Slide,
  TextField,
  Typography,
} from '@mui/material';
import { Fragment, forwardRef, useEffect, useState } from 'react';
import {
  toDateRange,
  toSummaryBirthDate,
  // toReadableDateTimeString,
  toTimeRange,
} from '../../utils/dateFormatter';
import { useMediaQuery } from '@mui/material';
import { toCurrencyForm } from '../../utils/stringFormatter';
import { getDiscountValue } from '../../utils/numberFormatter';
import { LoadingButton } from '@mui/lab';
import FormTextField from '../FormTextField/FormTextField';
import api from '../../services/apiClient';
import prodigiLogo from '../../assets/Color horizontal.png';
import SHOMWaiverDialog from './SHOMWaiverDialog';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const TicketSummaryData = ({
  label,
  text,
  width = '100%',
  letterSpacing,
  multiline,
}) => (
  <TextField
    sx={{
      marginBottom: '10px',
      width: width,
      letterSpacing,
    }}
    defaultValue={text}
    label={label}
    size="small"
    multiline={multiline}
    InputProps={{
      readOnly: true,
    }}
  />
);

const TicketSummary = ({
  showSummary,
  onClose,
  event,
  team,
  participants,
  emergency,
  selectedProdi,
  selectedYear,
  category,
  internalCode,
  order,
  onChoosePayment,
  isLoading = false,
}) => {
  const isMobile = useMediaQuery('(max-width: 899px)');
  //   console.log('ts-email ', order);
  //   console.log('ts-event ', event);
  //   console.log('ts-participant ', participants);
  //   console.log('ts-emergency ', emergency);
  //   console.log('ts-category ', category);
  const isWHM = event?.eventId === 90 || event?.eventId === 91;
  //#region variable, state, load
  const [bill, setBill] = useState();
  const [coupon, setCoupon] = useState({ code: '', data: {} });
  const [isGetCouponData, setIsGetCouponData] = useState(false);
  const [sohmWaiverChecked, setSohmWaiverChecked] = useState(false);
  //#endregion

  //#region use effect
  useEffect(() => {
    if (!showSummary) return;

    // console.log('internalCode ', internalCode);

    // if (!internalCode || !internalCode.code) {
    // console.log('internalCode null');
    setBill(category?.registrationFee);
    setCoupon({ code: '', data: {} });
    // } else {
    //   console.log('internalcode not null');
    //   setCoupon({ code: internalCode.code, data: internalCode });
    //   const totalBill = getTotalBill(
    //     category?.registrationFee,
    //     internalCode?.coupon_category,
    //     internalCode?.coupon_value
    //   );
    //   setBill(totalBill);
    // }
  }, [category, showSummary]);
  //#endregion

  //#region function
  const handleOnClose = () => {
    if (isLoading) return;

    onClose();
  };

  const handleDataChange = (e) => {
    const updated = { ...coupon };
    updated.code = e.target.value;
    setCoupon(updated);
  };

  const handleGetCouponData = async () => {
    // console.log('ts-event ', event);
    // console.log('ts-coupon ', coupon);
    // return console.log(coupon);
    if (coupon.code === '') return alert('Input Coupon Code.');

    try {
      setIsGetCouponData((prev) => !prev);
      const { data: couponData } = await api.get(
        `/coupon/validate/${event?.eventId}/${coupon.code}/${category?.categoryId}`,
        // `/events/offline/coupon/${event?.eventId}/${coupon.code}`
      );

      const updated = { ...coupon };
      updated['data'] = couponData;
      // console.log('ticket summary get coupon data');
      // console.log(updated);
      setCoupon(updated);

      const totalBill = getTotalBill(
        category?.registrationFee,
        couponData?.coupon_category,
        couponData?.coupon_value,
      );

      setBill(totalBill);

      setIsGetCouponData((prev) => !prev);
    } catch (error) {
      setIsGetCouponData((prev) => !prev);
      setCoupon({ code: '', data: {} });
      alert(error.response.data);
    }
  };

  const getTotalBill = (registrationFee, couponCategory, couponValue) => {
    let totalBill = parseInt(registrationFee);
    let value = parseInt(couponValue);

    let result = 0;
    switch (couponCategory) {
      case 'sale':
        result = parseInt(totalBill) - parseInt(value);
        break;
      case 'discount':
        result = totalBill - (totalBill * value) / 100;
        break;
      default:
        break;
    }

    // console.log(result);
    return result;
  };

  const handleChoosePayment = () => {
    // console.log(event.eventId);
    if (event?.eventId !== 92 && event?.eventId !== 92)
      return onChoosePayment({ bill, coupon });

    if (sohmWaiverChecked === false)
      return alert(
        'Please agree our Term and Condition to continue your transaction.',
      );
    onChoosePayment({ bill, coupon });
  };
  //#endregion

  return (
    <Fragment>
      <Dialog fullScreen open={showSummary} TransitionComponent={Transition}>
        <DialogContent sx={{ padding: { xs: '2rem 2rem', lg: '2rem 4rem' } }}>
          <Card>
            <CardContent>
              <Grid container spacing={2}>
                {/* tab left */}
                <Grid item xs={12} md={3}>
                  {/* event info */}
                  <Typography variant="h5" gutterBottom>
                    {'Race Info'}
                  </Typography>
                  <Box
                    sx={{
                      m: 1,
                      display: 'flex',
                      flexDirection: 'column',
                      flexGrow: 1,
                    }}
                  >
                    <TicketSummaryData
                      text={event?.eventLocation}
                      label={isWHM ? 'Lokasi' : 'Location'}
                      multiline={true}
                    />
                    <TicketSummaryData
                      text={toDateRange(event?.startDate, event?.endDate)}
                      label={isWHM ? 'Tanggal' : 'Date'}
                      letterSpacing={1}
                    />
                    <TicketSummaryData
                      text={toTimeRange(event?.startDate, event?.endDate)}
                      label={isWHM ? 'Waktu' : 'Time'}
                      letterSpacing={1}
                    />
                  </Box>
                  {/* racepack info */}
                  <Typography variant="h5" gutterBottom>
                    {'Racepack Info'}
                  </Typography>
                  {event?.eventId !== 90 && event?.eventId !== 91 && (
                    <Box
                      sx={{ m: 1, display: 'flex', flexDirection: 'column' }}
                    >
                      <TicketSummaryData
                        text={event?.racepackCollection}
                        label={isWHM ? 'Lokasi' : 'Location'}
                        multiline={true}
                      />
                      <TicketSummaryData
                        text={toDateRange(
                          event?.startRacepackCollectionDate,
                          event?.endRacepackCollectionDate,
                        )}
                        label={isWHM ? 'Tanggal' : 'Date'}
                        letterSpacing={1}
                      />
                      <TicketSummaryData
                        text={toTimeRange(
                          event?.startRacepackCollectionDate,
                          event?.endRacepackCollectionDate,
                        )}
                        label={isWHM ? 'Waktu' : 'Time'}
                        letterSpacing={1}
                      />
                    </Box>
                  )}
                  {(event?.eventId === 90 || event?.eventId === 91) && (
                    <Box
                      sx={{ m: 1, display: 'flex', flexDirection: 'column' }}
                    >
                      <TicketSummaryData
                        text={event?.racepackCollection}
                        label={isWHM ? 'Lokasi' : 'Location'}
                        multiline={true}
                      />
                      <TicketSummaryData
                        text={toDateRange(
                          '2026-10-02 10:00:00',
                          '2026-10-02 22:00:00',
                        )}
                        label={isWHM ? 'Tanggal' : 'Date'}
                        letterSpacing={1}
                      />
                      <TicketSummaryData
                        text={toTimeRange(
                          '2026-10-02 10:00:00',
                          '2026-10-02 22:00:00',
                        )}
                        label={isWHM ? 'Waktu' : 'Time'}
                        letterSpacing={1}
                      />

                      <TicketSummaryData
                        text={toDateRange(
                          '2026-10-03 10:00:00',
                          '2026-10-03 20:00:00',
                        )}
                        label={isWHM ? 'Tanggal' : 'Date'}
                        letterSpacing={1}
                      />
                      <TicketSummaryData
                        text={toTimeRange(
                          '2026-10-03 10:00:00',
                          '2026-10-03 20:00:00',
                        )}
                        label={isWHM ? 'Waktu' : 'Time'}
                        letterSpacing={1}
                      />
                    </Box>
                  )}
                </Grid>

                {/* tab middle */}
                <Grid item xs={12} md={6}>
                  {/* email */}
                  <Typography variant="h5">Email</Typography>
                  <Box sx={{ m: 1 }}>
                    <TicketSummaryData text={order?.email?.value} />
                  </Box>
                  {/* team */}
                  {!!team?.name?.value && (
                    <>
                      <Typography variant="h5">Team</Typography>
                      <Box sx={{ m: 1 }}>
                        <TicketSummaryData text={team?.name?.value} />
                      </Box>
                    </>
                  )}
                  {/* participants */}
                  <Typography variant="h5" sx={{ marginBottom: '10px' }}>
                    {participants?.length === 1
                      ? 'Participant'
                      : 'Participants'}
                  </Typography>
                  <Grid item container className={'scroll'}>
                    {participants?.map((pt, idx) => (
                      <Grid key={idx} item xs={12} lg={6}>
                        <DialogContentText variant="h5" align="center">
                          {event?.eventId === 88 ? '' : `Peserta ${idx + 1}`}
                        </DialogContentText>
                        <Box
                          sx={{
                            m: 1,
                            display: 'flex',
                            flexDirection: 'column',
                          }}
                        >
                          <TicketSummaryData
                            text={pt?.name?.value}
                            label={isWHM ? 'Nama' : 'Name'}
                          />
                          {!!pt?.runningFor?.value && (
                            <TicketSummaryData
                              text={pt?.runningFor?.value}
                              label={'Running For (printed on BIB)'}
                            />
                          )}
                          {!!pt?.gender?.value && (
                            <TicketSummaryData
                              text={pt?.gender?.value}
                              label={isWHM ? 'Jenis Kelamin' : 'Gender'}
                            />
                          )}
                          {!!pt?.nationality?.value && (
                            <TicketSummaryData
                              text={pt?.nationality?.value}
                              label={isWHM ? 'Kebangsaan' : 'Nationality'}
                            />
                          )}
                          {!!pt?.idType?.value && (
                            <TicketSummaryData
                              text={pt?.idType?.value}
                              label={
                                isWHM ? 'Id Type' : 'Id TypeJenis Identitas'
                              }
                            />
                          )}
                          {!!pt?.idNumber?.value && (
                            <TicketSummaryData
                              text={pt?.idNumber?.value}
                              label={isWHM ? 'Nomor Identitas' : 'Id Number'}
                            />
                          )}
                          {(event?.eventId === 64 || event?.eventId === 66) && (
                            <>
                              <TicketSummaryData
                                text={pt?.street?.value}
                                label={'Alamat'}
                              />
                              <TicketSummaryData
                                text={pt?.kelurahan?.value}
                                label={'Kelurahan'}
                              />
                              <TicketSummaryData
                                text={pt?.kecamatan?.value}
                                label={'Kecamatan'}
                              />
                              <TicketSummaryData
                                text={pt?.kota?.value}
                                label={'Kota'}
                              />
                              <TicketSummaryData
                                text={pt?.kodepos?.value}
                                label={'Kode Pos'}
                              />
                            </>
                          )}
                          {(category.categoryId === 167 ||
                            category.categoryId === 174) && (
                            <TicketSummaryData
                              text={pt?.tindakanoperasi?.value}
                              label={'Tindakan Operasi, Tanggal, RS'}
                            />
                          )}
                          {(category.categoryId === 171 ||
                            category.categoryId === 177) && (
                            <TicketSummaryData
                              text={pt?.npa?.value}
                              label={'No NPA'}
                            />
                          )}
                          {!!pt?.birthDate?.value && (
                            <TicketSummaryData
                              text={toSummaryBirthDate(pt?.birthDate?.value)}
                              label={`${isWHM ? 'Tanggal Lahir ' : 'Birth Date '}dd / mm / yyyy`}
                              letterSpacing={1}
                            />
                          )}
                          {!!pt?.bloodType?.value && (
                            <TicketSummaryData
                              text={pt?.bloodType?.value}
                              label={isWHM ? 'Golongan Darah' : 'Blood Type'}
                            />
                          )}
                          {!!pt?.contact?.value && (
                            <TicketSummaryData
                              text={pt?.contact?.value}
                              label={isWHM ? 'Kontak' : 'Phone Number'}
                            />
                          )}
                          <TicketSummaryData
                            text={
                              pt?.orgCom?.value === '' ? '-' : pt?.orgCom?.value
                            }
                            label={
                              isWHM
                                ? 'Organisasi / Komunitas'
                                : event?.eventId === 88
                                  ? 'Institution'
                                  : event?.eventId === 92
                                    ? 'User Type'
                                    : 'Organization / Community'
                            }
                          />

                          {event?.eventId === 92 &&
                            pt?.orgCom?.value !== '' &&
                            pt?.orgCom?.value !== 'Umum' && (
                              <TicketSummaryData
                                text={selectedProdi}
                                label={'Study Program'}
                              />
                            )}

                          {event?.eventId === 92 &&
                            pt?.orgCom?.value !== '' &&
                            pt?.orgCom?.value !== 'Umum' && (
                              <TicketSummaryData
                                text={selectedYear}
                                label={'Academic Year'}
                              />
                            )}

                          {!!pt?.size?.value && (
                            <TicketSummaryData
                              text={pt?.size?.value}
                              label={isWHM ? 'Ukuran' : 'Size'}
                            />
                          )}
                          {!!pt?.emergencyPerson?.value && (
                            <TicketSummaryData
                              text={pt?.emergencyPerson?.value}
                              label={'Emergency Person'}
                            />
                          )}
                          {!!pt?.emergencyContact?.value && (
                            <TicketSummaryData
                              text={pt?.emergencyContact?.value}
                              label={'Emergency Phone Number'}
                            />
                          )}
                          {!!pt?.emergencyRelation?.value && (
                            <TicketSummaryData
                              text={pt?.emergencyRelation?.value}
                              label={'Emergency Relation'}
                            />
                          )}
                        </Box>
                      </Grid>
                    ))}

                    {/* emergency person */}
                    {!!emergency?.person?.value && (
                      <Box>
                        <Typography variant="h5">
                          {isWHM ? 'Kontak Darurat' : 'Emergency'}
                        </Typography>
                        <Box sx={{ m: 1 }}>
                          <TicketSummaryData
                            text={emergency?.person?.value}
                            label={'Nama'}
                          />
                          <TicketSummaryData
                            text={emergency?.contact?.value}
                            label={'Kontak'}
                          />
                          {!!emergency?.relation?.value && (
                            <TicketSummaryData
                              text={emergency?.relation?.value}
                              label={'Hubungan'}
                            />
                          )}
                        </Box>
                      </Box>
                    )}
                  </Grid>
                </Grid>

                {/* tab right */}
                <Grid item xs={12} md={3}>
                  {
                    //#region category
                  }
                  <Typography variant="h5" gutterBottom>
                    {isWHM ? 'Kategori' : 'Category'}
                  </Typography>
                  <Box sx={{ m: 1, display: 'flex', flexDirection: 'column' }}>
                    <TicketSummaryData
                      text={category?.name}
                      label={isWHM ? 'Nama' : 'Name'}
                    />
                    <TicketSummaryData
                      text={`${participants?.length} ${
                        participants?.length === 1
                          ? isWHM
                            ? 'Peserta'
                            : 'participant'
                          : 'participants'
                      }`}
                      label={isWHM ? 'Total Peserta' : 'Total Participants'}
                    />
                    <TicketSummaryData
                      text={category?.priceLabel}
                      label={isWHM ? 'Grup Harga' : 'Price Group'}
                    />
                  </Box>
                  {
                    //#endregion
                  }

                  {
                    //#region insurance
                  }
                  {event?.isInsuranceBundled > 0 && (
                    <Box
                      display={'flex'}
                      justifyContent={'flex-start'}
                      marginBottom={'10px'}
                      flexDirection={'column'}
                      borderRadius={'14px'}
                      padding={'10px 16px'}
                      flex={1}
                      sx={{
                        border: 3,
                        borderColor: 'grey.200',
                      }}
                    >
                      <Box>
                        <Box display={'flex'} alignItems={'center'}>
                          <FormLabel
                            sx={{
                              fontSize: '20px',
                              flexGrow: 1,
                              fontWeight: '600',
                            }}
                          >
                            {'Insurance'}
                          </FormLabel>
                          <img
                            src={prodigiLogo}
                            alt="prodigi"
                            style={{
                              height: '24px',
                              width: '100px',
                              objectFit: 'contain',
                            }}
                          />
                        </Box>

                        <Divider style={{ margin: '10px 0' }} />
                        <Box display={'flex'}>
                          <FormLabel
                            sx={{
                              fontSize: '16px',
                              flexGrow: 1,
                              fontWeight: '600',
                            }}
                          >
                            {'Asuransi Kecelakaan Diri'}
                          </FormLabel>
                          <Typography variant="body1" fontWeight={'600'}>
                            {'Bundled'}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  )}
                  {
                    //#endregion
                  }

                  {
                    //#region coupons
                  }
                  <Box
                    display={'flex'}
                    justifyContent={'flex-start'}
                    marginBottom={'10px'}
                    flexDirection={'column'}
                    borderRadius={'14px'}
                    padding={'10px 16px'}
                    flex={1}
                    sx={{
                      border: 3,
                      borderColor: 'grey.200',
                    }}
                  >
                    <Box display={'flex'}>
                      <FormLabel
                        sx={{
                          fontSize: '16px',
                          flexGrow: 1,
                          fontWeight: '600',
                        }}
                      >
                        Biaya Pendaftaran
                      </FormLabel>
                      <Typography variant="body1" fontWeight={'600'}>
                        {category?.registrationFee === '0'
                          ? 'FREE'
                          : `Rp
                                  ${toCurrencyForm(category?.registrationFee)}`}
                      </Typography>
                    </Box>
                    {coupon?.data?.coupon_category && (
                      <Box display={'flex'}>
                        <FormLabel
                          sx={{
                            fontSize: '16px',
                            flexGrow: 1,
                            fontWeight: '600',
                          }}
                        >
                          {coupon?.data?.coupon_category === 'discount'
                            ? `Disc(${coupon?.data?.coupon_value}%)`
                            : coupon?.data?.coupon_category}
                        </FormLabel>
                        <Typography variant="body1" fontWeight={'600'}>
                          {coupon?.data?.coupon_category === 'sale'
                            ? `Rp ${toCurrencyForm(coupon?.data?.coupon_value)}`
                            : `Rp ${toCurrencyForm(
                                getDiscountValue(
                                  category?.registrationFee,
                                  coupon?.data?.coupon_value,
                                ),
                              )}`}
                        </Typography>
                      </Box>
                    )}
                    <Divider
                      sx={{
                        marginTop: '4px',
                        marginBottom: '4px',
                        marginLeft: { xs: '78%', sm: '82%', md: '60%' },
                      }}
                    />
                    <Box display={'flex'}>
                      <FormLabel
                        sx={{
                          fontSize: '16px',
                          flexGrow: 1,
                          fontWeight: '600',
                        }}
                      >
                        Total Biaya
                      </FormLabel>
                      <Typography variant="body1" fontWeight={'600'}>
                        {bill > 0 ? `Rp ${toCurrencyForm(bill)}` : 'FREE'}
                      </Typography>
                    </Box>
                    {event?.isCoupon > 0 && (
                      <Divider sx={{ margin: '4px 0' }} />
                    )}

                    {event?.isCoupon > 0 && (
                      <FormControl>
                        <FormLabel
                          id="coupon-form"
                          sx={{ fontSize: '18px', fontWeight: '600' }}
                        >
                          Coupon
                        </FormLabel>
                        <Box sx={{ marginTop: '10px' }}>
                          <FormTextField
                            index={0}
                            i={0}
                            label={'Coupon Code'}
                            value={coupon.code}
                            readOnly={!!coupon?.data?.code}
                            disabled={!!coupon?.data?.code}
                            onChange={handleDataChange}
                          />
                          <LoadingButton
                            variant="contained"
                            fullWidth
                            onClick={handleGetCouponData}
                            loading={isGetCouponData}
                            disabled={!!coupon?.data?.code}
                          >
                            Use Coupon
                          </LoadingButton>
                        </Box>
                      </FormControl>
                    )}
                  </Box>
                  {event?.eventId === 92 && (
                    <Box
                      display={'flex'}
                      flexDirection={'row'}
                      alignItems={'flex-start'}
                    >
                      <Checkbox
                        checked={sohmWaiverChecked}
                        onChange={() =>
                          setSohmWaiverChecked(!sohmWaiverChecked)
                        }
                      />
                      Saya menyatakan telah membaca dan menyetujui keseluruhan
                      "Term and Condition"
                      <SHOMWaiverDialog
                        onAgreed={() => setSohmWaiverChecked(true)}
                      />
                    </Box>
                  )}
                  {isMobile && (
                    <Box
                      sx={{
                        marginTop: '20px',
                        display: 'flex',
                        justifyContent: 'flex-end',
                      }}
                    >
                      {!isLoading && (
                        <Button autoFocus onClick={handleOnClose}>
                          {isWHM ? 'Tutup' : 'Close'}
                        </Button>
                      )}
                      <LoadingButton
                        onClick={handleChoosePayment}
                        autoFocus
                        loading={isLoading}
                      >
                        {bill > 0 ? 'Pilih Pembayaran' : 'Daftar'}
                      </LoadingButton>
                    </Box>
                  )}
                  {
                    //#endregion
                  }
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </DialogContent>
        {!isMobile && (
          <DialogActions>
            {!isLoading && (
              <Button autoFocus onClick={handleOnClose}>
                {isWHM ? 'Tutup' : 'Close'}
              </Button>
            )}
            <LoadingButton
              onClick={handleChoosePayment}
              autoFocus
              loading={isLoading}
            >
              {bill > 0
                ? isWHM
                  ? 'Pilih Pembayaran'
                  : 'Choose Payment'
                : isWHM
                  ? 'Daftar'
                  : 'Register'}
            </LoadingButton>
          </DialogActions>
        )}
      </Dialog>
    </Fragment>
  );
};

export default TicketSummary;
